import { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import ProjectBaselineSummary from "./ProjectBaselineSummary";
import { ProjectBaselineDetail } from "../../interfaces/baselineInterface";
import SummaryBaseline from "./SummeryBaseLine";

interface SummaryListProps {
  baselineId: number;
  allUpdatedRows: ProjectBaselineDetail[];
  monthName: string;
  year: number;
  forecastType: number;
}

const SummaryList: React.FC<SummaryListProps> = ({
  baselineId,
  allUpdatedRows,
  monthName,
  year,
  forecastType,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const HandletabClick = () => {
    setActiveTab(1);
    console.log('Active Tab Index:', activeTab);
  }

  return (
    <Box sx={{ width: "100%" }}>
      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={(e, v) => setActiveTab(v)}
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab label="Summary" />
        <Tab label="Summary Changes" />
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ mt: 0 }}>

        {activeTab === 0 && (
          <SummaryBaseline
            allUpdatedRows={allUpdatedRows}
            monthName={monthName}
            year={year}
            currentBaselineId={baselineId}
            forecastType={forecastType}
          />
        )}

        {activeTab === 1 && (
          <ProjectBaselineSummary baselineId={baselineId} />
        )}


      </Box>
    </Box>
  );
};

export default SummaryList;
